import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { MEMORY_MAP_IMAGES } from '../../shared/memory-map-assets';
import { useAutoSubmitAnswer } from '../../shared/use-auto-submit-answer';
import styles from './QuestionGridSlideV1.css';

const cx = classnames.bind(styles);

function QuestionGridSlideV1({ id, question, hint, answers, submitAnswer, submitTemporaryAnswer, userResponse = {}, delay }) {
    const { selectAnswer } = useAutoSubmitAnswer({ id, question, userResponse, submitAnswer, submitTemporaryAnswer, delay });

    return (
        <div className={styles.form} key={id}>
            <div className={styles.text}>
                <h1 className={styles.question}>{question}</h1>
                <p className={styles.hint}>{hint}</p>
            </div>
            <ul className={styles.grid}>
                {answers.map(answer => {
                    const isChecked = userResponse?.id === answer.id;

                    return (
                        <li key={answer.id}>
                            <button
                                type='button'
                                className={cx('option', { checked: isChecked })}
                                onClick={selectAnswer({ id: answer.id, text: answer.text })}
                                aria-pressed={isChecked}
                            >
                                <span className={styles.picture}>
                                    <img
                                        src={MEMORY_MAP_IMAGES[answer.imageId]}
                                        alt=''
                                        className={styles.image}
                                        decoding='async'
                                        width='952'
                                        height='952'
                                    />
                                </span>
                                <span className={styles.label}>{answer.text}</span>
                            </button>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

QuestionGridSlideV1.propTypes = {
    id: PropTypes.number.isRequired,
    question: PropTypes.string.isRequired,
    hint: PropTypes.string,
    answers: PropTypes.array.isRequired,
    submitAnswer: PropTypes.func.isRequired,
    submitTemporaryAnswer: PropTypes.func.isRequired,
    userResponse: PropTypes.object,
    delay: PropTypes.number
};

export {
    QuestionGridSlideV1
};
